export const TIPO_DIDACTICA_UNIVERSITARIA = 1;
/** Actualización Docente — sin comprobante PDF */
export const TIPO_ACTUALIZACION_DOCENTE = 2;
export const TIPO_EIDU = 3;

export function isActualizacionDocente(tipoPeriodo: number | string | undefined) {
  return Number(tipoPeriodo) === TIPO_ACTUALIZACION_DOCENTE;
}

export function isEidu(tipoPeriodo: number | string | undefined) {
  return Number(tipoPeriodo) === TIPO_EIDU;
}
